var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L0 2V16L10 18V0ZM12 2V4H14V6H12V8H14V10H12V12H14V14H12V16H19C19.552 16 20 15.552 20 15V3C20 2.448 19.552 2 19 2H12ZM16 4H18V6H16V4ZM2.17578 5.29688H3.95312L4.87695 7.51172C4.95195 7.69272 5.00841 7.90263 5.06641 8.14062H5.0918C5.1248 7.99762 5.19197 7.77914 5.29297 7.49414L6.32227 5.29688H7.94336L6.00781 8.9668L8 12.7031H6.27148L5.1582 10.2891C5.1162 10.2041 5.06639 10.0329 5.02539 9.79492H5.00977C4.98477 9.90892 4.93437 10.0796 4.85938 10.3086L3.73633 12.7031H2L4.06055 8.99609L2.17578 5.29688ZM16 8H18V10H16V8ZM16 12H18V14H16V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcell);
export default __webpack_public_path__ + "static/media/excell.6041c1f46189711ffe0b06d3faf45904.svg";
export { ForwardRef as ReactComponent };